/**
 * Movepro CRM API interface
 *
 * @package Movepro CRM
 * @module User
 */

const ROUTE = '/users';

function index() {
    return window.tenantAxios.get(`${ROUTE}/search`);
}

function create(userData) {
    return window.tenantAxios.post(ROUTE, userData);
}

function update(userId, userData) {
    return window.tenantAxios.patch(`${ROUTE}/${userId}`, {
        user_id: userId,
        ...userData,
    });
}

function updatePreferences(userId, payload) {
    return window.tenantAxios.patch(`${ROUTE}/${userId}/preferences`, payload);
}

function retrieve(userId) {
    return window.tenantAxios.get(`${ROUTE}/${userId}`);
}

function destroy(userId) {
    return window.tenantAxios.delete(`${ROUTE}/${userId}`);
}

// Helper API Services

function notifications(userId) {
    return window.tenantAxios.get(`${ROUTE}/${userId}/notifications`);
}

function requestResetPassword(email) {
    return window.centralAxios.post('auth/forgot-password', { email });
}

function confirmResetPassword(token, email, password, password_confirmation) {
    return window.centralAxios.post('auth/reset-password', {
        token: token,
        email: email,
        password: password,
        password_confirmation: password_confirmation,
    });
}

export default {
    index,
    create,
    retrieve,
    update,
    updatePreferences,
    destroy,
    notifications,
    requestResetPassword,
    confirmResetPassword,
};
